export const cmvReportV2 = {
	label: "CMV",
	description:
		"El CMV (Costo de Mercancías Vendidas) es un indicador financiero que representa los costos directos.",
	states: {
		empty: {
			title: "No se encontraron datos de CMV",
			description: "No hay información de CMV para el período seleccionado.",
		},
		error: {
			title: "No se pudo cargar el CMV",
			description:
				"Ocurrió un error al cargar el informe de CMV. Inténtalo de nuevo en unos instantes.",
		},
	},
	kpis: {
		itemsSold: "Artículos vendidos",
		grossRevenue: "Facturación bruta",
		totalCost: "Costo total",
		marginCmv: "Margen CMV",
		cmvPercent: "CMV en porcentaje",
	},
	header: {
		periodPlaceholder: "Seleccione el período",
		export: "Exportar Excel",
		type: {
			all: "Todos los productos",
			fromPlace: "Productos del place",
			fromVendor: "Productos del proveedor",
		},
	},
	filters: {
		searchPlaceholder: "Buscar por producto o SKU",
		categoriesPlaceholder: "Todas las categorías",
		viewBy: {
			byCategory: "Visualizar por categorías",
			byProduct: "Visualizar por productos",
		},
	},
	chart: {
		title: "Facturación vs CMV por categoría",
		legend: {
			revenue: "Facturación",
			cmv: "CMV",
		},
		tooltip: {
			revenue: "Facturación",
			cmv: "CMV",
		},
		empty: {
			title: "Sin datos para el gráfico",
			description:
				"No hay categorías con ventas para el período y filtros seleccionados.",
		},
	},
	table: {
		columns: {
			category: "CATEGORÍA",
			soldQty: "CANT. VENDIDA",
			grossRevenue: "FACTURACIÓN BRUTA",
			totalCost: "COSTO TOTAL",
			costPercent: "COSTO PORCENTUAL",
			cmv: "CMV",
			margin: "MARGEN",
			product: "Producto",
			sku: "SKU",
			productSoldQty: "Cant. vendida",
			losses: "Pérdidas",
			unitValue: "Valor unit.",
			unitCost: "Costo unit.",
			productTotalValue: "Valor total",
			productTotalCost: "Costo total",
			productMargin: "Margen",
			productCmv: "CMV",
		},
		empty: {
			title: "No se encontraron productos",
			description: "No hay productos para los filtros seleccionados.",
		},
	},
};
